import { render, staticRenderFns } from "./ProductPackSize.vue?vue&type=template&id=5824b4e7"
import script from "./ProductPackSize.vue?vue&type=script&lang=js"
export * from "./ProductPackSize.vue?vue&type=script&lang=js"
import style0 from "./ProductPackSize.vue?vue&type=style&index=0&id=5824b4e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports